"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.timmSignedMessages = exports.TimmSigned = void 0;
const schema_1 = require("../../schema");
var TimmSigned;
(function (TimmSigned) {
    TimmSigned["TIMM_SIGNED"] = "TIMM_SIGNED";
})(TimmSigned || (exports.TimmSigned = TimmSigned = {}));
exports.timmSignedMessages = {
    [TimmSigned.TIMM_SIGNED]: {
        id: "ltx.patientStatementOfConsentTimm.timmSigned.TIMM_SIGNED",
        defaultMessage: "A TIMM hozzájáruló nyilatkozatot a beteg aláírásával elfogadta"
    }
};
const timmSigned = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(TimmSigned.TIMM_SIGNED)
]).interpretation({ vocab: "ltx", code: "signed_statement_of_consent_timm" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ timmSigned });
